import './css/App.css';
import { useEffect, useState } from 'react';

import Home from './Home'
import CanvasPage from './CanvasPage';

import NavBar from '../components/NavBar';
import CommitCanvas from '../components/CommitCanvas';
import LoginModal from '../components/LoginModal';
import LandingBackground from '../components/LandingBackground';

let BACKEND_URL = process.env.REACT_APP_API_URL;
const CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;

function App() {
  const [rerender, setRender] = useState(false);
  const [userData, setUserData] = useState({});
  const [token, setToken] = useState('')
  const [userRepos, setUserRepos] = useState([]);
  const [starredRepos, setStarredRepos] = useState(null);

  useEffect(() => {
    // console.log(userData);
  }, [userData]);

  useEffect(() => {
    // console.log(userRepos);
  }, [userRepos]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const sessionToken = localStorage.getItem('session_token');
    // console.log(code)
    // console.log(sessionToken)
    setToken(sessionToken)

    if (code && sessionToken === null) {
      const getAccessToken = async () => {
        await fetch(`${BACKEND_URL}/github/getAccessToken?code=${code}`, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then((data) => {
            // console.log(code)
            console.log(data)
            if (data.session_token) {
              localStorage.setItem('session_token', data.session_token);
              getUserData();
              getUserRepos();
              setRender(!rerender);
            }
          })
          .catch(e => {
            console.log(e)
          })
      };
      getAccessToken();
    } else if (sessionToken) {
      getUserData();
      getUserRepos();
    }
  }, [rerender]);

  const getUserData = async () => {
    const sessionToken = localStorage.getItem('session_token');
    await fetch(`${BACKEND_URL}/github/getUserData`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
        if (data.starred_repos) {
          setStarredRepos(data.starred_repos);
        }
      });
  };

  const getUserRepos = async () => {
    const sessionToken = localStorage.getItem('session_token');
    await fetch(`${BACKEND_URL}/github/getUserRepos`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => setUserRepos(data));
  };

  const getRepoContent = async (repo_name) => {
    await fetch(`${BACKEND_URL}/github/getUserRepoContent?repo_name=${repo_name}&username=${userData.login}`, {
      method: 'GET',
      headers: {
      'Authorization': `Bearer ${localStorage.getItem('session_token')}`,
      'Accept': 'application/vnd.github.v3+json'
      }
    }).then((response) => {
      return response.json()
    }).then((data) => {
      console.log(data)
    }).catch((error) => {
      console.error('Error fetching repo content:', error)
    })
  }

  const handleRepoSelect = (e) => {
    const repo_name = e.target.name
    console.log(repo_name)
    getRepoContent(repo_name)
  }

  const loginWithGithub = () => {
    window.location.assign(
      // `https://github.com/login/oauth/authorize?client_id=${CLIENT_ID}&scope=repo&prompt=select_account`
      `https://github.com/login/oauth/authorize?client_id=${CLIENT_ID}&scope=repo,delete_repo&prompt=select_account`
      // `https://github.com/login/oauth/authorize?client_id=${CLIENT_ID}&scope=read:user,user:email,user,repo,public_repo,repo:status,repo_deployment,repo:invite,delete_repo,read:org,write:org,admin:org,admin:repo_hook,write:repo_hook,read:repo_hook,gist&prompt=select_account`

    );
  };

  const logout = () => {
    localStorage.removeItem('session_token');
    setUserData({})
    setRender(!rerender);
  };

  return (
    <div className="App">
      {token ? 
      <>
      <NavBar auth={userData} logout={logout}/>
      < CommitCanvas 
        contributions={userData.contributions} 
        token={token} 
        username = {userData.login} 
        userRepos={userRepos}
        starredRepos={starredRepos}
        setStarredRepos={setStarredRepos}
      />
      </>
      :
      <>
      <NavBar logout={logout}/>
      <LandingBackground />
      <LoginModal loginWithGithub={loginWithGithub}/>
      {/* <h1>Not logged in</h1>
      <button onClick={loginWithGithub} className="login-button">
        Login with Github
      </button> */}
      </>
      }
    </div>
  );
}

export default App;
